<div
    #container
    class="sb-split-button">
    <div
        class="d-flex sb-split-button-wrapper"
        #splitMenuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="button.disabled ? null : splitMenu">
        <lib-button
            #button
            [qaTag]="qaTag ? qaTag + '-main-button' : ''"
            [kind]="kind"
            [size]="size"
            [stretch]="stretch"
            [loading]="loading"
            [disabled]="disabled"
            [prefixIcon]="prefixIcon"
            (click)="$event.stopPropagation()"
            (clicked)="ButtonClicked($event, splitMenuTrigger)">
            <ng-content
                select="[label]"
                label></ng-content>
        </lib-button>
        <lib-icon-button
            [qaTag]="qaTag ? qaTag + '-split-icon-button' : ''"
            [icon]="Icon.Common.CaretDown"
            [kind]="kind"
            [disabled]="loading || disabled"
            [size]="size"
            (clicked)="OpenMenuFromButton(splitMenuTrigger)"></lib-icon-button>
    </div>
</div>

<mat-menu
    #splitMenu="matMenu"
    [hasBackdrop]="hasBackdrop">
    @for (item of menuItemComponents; track item) {
        <div
            class="v3"
            [attr.data-sb-qa]="item.qaTag"
            [ngStyle]="{ 'min-width': menuWidth }">
            @if (item.menuDivider === MenuDivider.Above) {
                <mat-divider class="pb-2 mt-2 mx-2"></mat-divider>
            }
            <div class="ps-3 menu-item-header typography-body-medium-strong">
                <ng-container *ngTemplateOutlet="item.menuItemHeader"></ng-container>
            </div>

            @if (!item.hasSubOptions && !item.urlLink) {
                <button
                    [attr.data-sb-qa]="item.qaTag ? item.qaTag + '-button' : ''"
                    [matTooltip]="item.toolTipText"
                    matTooltipPosition="after"
                    [ngClass]="{ 'disable-menu-item': item.disabled, 'menu-item-default': !item.hint, 'menu-item-with-hint': item.hint }"
                    mat-menu-item
                    (click)="MenuItemClicked(item, $event)">
                    <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                </button>
            }
            @if (!item.hasSubOptions && item.urlLink) {
                <a
                    class="link-menu-item"
                    [attr.data-sb-qa]="item.qaTag ? item.qaTag + '-link' : ''"
                    [matTooltip]="item.toolTipText"
                    matTooltipPosition="after"
                    [ngClass]="{ 'disable-menu-item': item.disabled, 'menu-item-default': !item.hint, 'menu-item-with-hint': item.hint }"
                    mat-menu-item
                    [href]="item.urlLink"
                    routerLinkActive="active"
                    target="_blank"
                    (click)="MenuItemClicked(item, $event)"
                    onclick="return false;">
                    <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                </a>
            }
            @if (item.menuDivider === MenuDivider.Below) {
                <mat-divider class="pt-2 mt-2 mx-2"></mat-divider>
            }
        </div>
    }
</mat-menu>

<ng-template
    #menuItem
    let-item>
    @if (item.label) {
        <div
            class="d-flex align-items-center h-100 my-auto"
            [ngClass]="{ 'menu-item-under-group': item.hasGroupHeader }">
            @if (item.prefixIcon) {
                <lib-icon
                    [icon]="item.prefixIcon"
                    [size]="IconSize.ExtraSmall"
                    [visible]="item.prefixIconVisible"
                    class="pe-2"></lib-icon>
            }
            <div>
                <p class="typography-input">{{ item.label }}</p>
                @if (item.hint) {
                    <small>{{ item.hint }}</small>
                }
            </div>
            @if (item.suffixIcon) {
                <lib-icon
                    [icon]="item.suffixIcon"
                    [size]="IconSize.ExtraSmall"
                    [visible]="item.suffixIconVisible"
                    class="ps-2"></lib-icon>
            }
        </div>
    } @else {
        <div
            class="d-flex align-items-center h-100 my-auto"
            [ngClass]="{ 'menu-item-under-group': item.hasGroupHeader }">
            <ng-container *ngTemplateOutlet="item.menuItemContent"></ng-container>
        </div>
    }
</ng-template>
